import Main from "../Pages/Apporval/Scope1/StationaryCombustion/Main";
import Scope2DocumentationElectricity from "../Pages/Apporval/Scope2/Electricity/Main";
import Scope2DocumentationHeat from "../Pages/Apporval/Scope2/Heat/Main";
import Scope2DocumentationSteam from "../Pages/Apporval/Scope2/Steam/Main";
import GoodsService from "../Pages/Apporval/Scope3/GoodsService/GoodsService";
import BusinessTravelDocuments from "../Pages/Apporval/Scope3/BusinessTravel/BusinessTravel";
import EmployeeCommuteDocuments from "../Pages/Apporval/Scope3/EmployeeCommute/EmployeeCommute";
import TransportationDocuments from "../Pages/Apporval/Scope3/Transportation/Transportation";
import WasteGeneratedDocuments from "../Pages/Apporval/Scope3/WasteGenerated/WasteGenerated";
import CapitalGoodsApproval from "../Pages/Apporval/Scope3/CapitalGoods/CapitalGoods";
import UpstreamLeasedAssetsApproval from "../Pages/Apporval/Scope3/UpstreamLeasedAssets/UpstreamLeasedAssets";
import DownstreamLeasedAssetsApproval from "../Pages/Apporval/Scope3/DownstreamLeasedAssets/DownstreamLeasedAssets";
import FranchisesApproval from "../Pages/Apporval/Scope3/Franchises/Franchises";
import InvestmentsApproval from "../Pages/Apporval/Scope3/Investments/Investments";
import FuelEnergyActivitiesApproval from "../Pages/Apporval/Scope3/FuelEnergyActivities/FuelEnergyActivities";
import EOLTreatmentOfSoldProductsApproval from "../Pages/Apporval/Scope3/EOLTreatmentOfSoldProducts/EOLTreatmentOfSoldProducts";
import ProcessingOfSoldProductsApproval from "../Pages/Apporval/Scope3/ProcessingOfSoldProducts/ProcessingOfSoldProducts";
import UseOfSoldProductsApproval from "../Pages/Apporval/Scope3/UseOfSoldProducts/UseOfSoldProducts";
import MobileCombustionDocuments from "../Pages/Apporval/Scope1/MobileCombustion/MobileCombustionDocuments";
import FugitiveEmissionDocuments from "../Pages/Apporval/Scope1/FugitiveEmission/FugitiveEmissionDocuments";
import Social from "../Pages/Documentation/Social";
import GovernanceDocuments from "../Pages/Documentation/Governance/Governance";
import CarbonAvoidance from "../Pages/Apporval/Scope4/CarbonAvoidance/Main";
import CarbonOffsetting from "../Pages/Apporval/Scope4/CarbonOffsetting/Main";

export const ApporvalRoutes = [
  { path: "/approval/scope1/stationary-combustion", element: <Main /> },
  {
    path: "/approval/scope1/mobile-combustion",
    element: <MobileCombustionDocuments />,
  },
  {
    path: "/approval/scope1/fugitive-combustion",
    element: <FugitiveEmissionDocuments />,
  },
  {
    path: "/approval/scope2/Electricity",
    element: <Scope2DocumentationElectricity />,
  },
  {
    path: "/approval/scope2/Heat",
    element: <Scope2DocumentationHeat />,
  },
  {
    path: "/approval/scope2/Steam",
    element: <Scope2DocumentationSteam />,
  },
  {
    path: "/approval/scope3/goods-services",
    element: <GoodsService />,
  },
  {
    path: "/approval/scope3/transportation",
    element: <TransportationDocuments />,
  },
  {
    path: "/approval/scope3/employee-commute",
    element: <EmployeeCommuteDocuments />,
  },
  {
    path: "/approval/scope3/business-travel",
    element: <BusinessTravelDocuments />,
  },
  {
    path: "/approval/scope3/waste-generated",
    element: <WasteGeneratedDocuments />,
  },
  {
    path: "/approval/scope3/capital-goods",
    element: <CapitalGoodsApproval />,
  },
  {
    path: "/approval/scope3/upstream-leased-assets",
    element: <UpstreamLeasedAssetsApproval />,
  },
  {
    path: "/approval/scope3/downstream-leased-assets",
    element: <DownstreamLeasedAssetsApproval />,
  },
  {
    path: "/approval/scope3/franchises",
    element: <FranchisesApproval />,
  },
  {
    path: "/approval/scope3/investments",
    element: <InvestmentsApproval />,
  },
  {
    path: "/approval/scope3/fuel-energy-activities",
    element: <FuelEnergyActivitiesApproval />,
  },
  {
    path: "/approval/scope3/eol-treatment-of-sold-products",
    element: <EOLTreatmentOfSoldProductsApproval />,
  },
  {
    path: "/approval/scope3/processing-of-sold-products",
    element: <ProcessingOfSoldProductsApproval />,
  },
  {
    path: "/approval/scope3/use-of-sold-products",
    element: <UseOfSoldProductsApproval />,
  },
  {
    path: "/approval/scope4/CarbonAvoidance",
    element: <CarbonAvoidance />,
  },
  {
    path: "/approval/scope4/CarbonOffsetting",
    element: <CarbonOffsetting />,
  },
];
